import React from 'react';
import { LucideIcon } from '../../LucideIcon';

const CART_ITEM_QUANTITY_DECREMENT_TRIGGER_TEST_ID = 'cart-item-quantity-decrement-trigger';
const CART_ITEM_QUANTITY_INCREMENT_TRIGGER_TEST_ID = 'cart-item-quantity-increment-trigger';
const CART_ITEM_QUANTITY_INPUT_TEST_ID = 'cart-item-quantity-input';

interface CartNumberInputProps {
  value?: string;
  defaultValue?: string;
  min?: number;
  max?: number;
  step?: number;
  onValueChange?: (details: { value: string; valueAsNumber: number }) => void;
  'data-testid'?: string;
}

const CartNumberInput = ({
  value,
  defaultValue = '1',
  min = 1,
  max = 999,
  step = 1,
  onValueChange,
  ...rest
}: CartNumberInputProps) => {
  const displayValue = value ?? defaultValue;
  const numericValue = Number(displayValue) || min;

  const handleDecrement = () => {
    const next = Math.max(min, numericValue - step);
    onValueChange?.({ value: String(next), valueAsNumber: next });
  };

  const handleIncrement = () => {
    const next = Math.min(max, numericValue + step);
    onValueChange?.({ value: String(next), valueAsNumber: next });
  };

  return (
    <div className="flex flex-row gap-0 border border-neutral-100 rounded-[4px]">
      <button
        type="button"
        onClick={handleDecrement}
        disabled={numericValue <= min}
        data-testid={CART_ITEM_QUANTITY_DECREMENT_TRIGGER_TEST_ID}
        className="flex items-center justify-center w-6 h-6 border-none bg-transparent hover:bg-transparent disabled:opacity-50"
      >
        <LucideIcon name="Minus" className="text-neutral-600" />
      </button>
      <input
        type="text"
        readOnly
        value={displayValue}
        data-testid={CART_ITEM_QUANTITY_INPUT_TEST_ID}
        className="w-[38px] h-6 text-center border-y-0 border-x border-neutral-100 rounded-none bg-transparent outline-none p-0 text-sm"
      />
      <button
        type="button"
        onClick={handleIncrement}
        disabled={numericValue >= max}
        data-testid={CART_ITEM_QUANTITY_INCREMENT_TRIGGER_TEST_ID}
        className="flex items-center justify-center w-6 h-6 border-none bg-transparent hover:bg-transparent disabled:opacity-50"
      >
        <LucideIcon name="Plus" className="text-neutral-600" />
      </button>
    </div>
  );
};

export default CartNumberInput;
